module.exports = __webpack_public_path__ + "76835c8239deee32a5ad58b3e4bf06fc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/ripped-jeans-s.png
// module id = 1928
// module chunks = 0